export default __webpack_public_path__ + "static/media/dep0_0.08436c8d.jpg";